import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export type StockTakeStatus = "NoBeds" | "Over" | "Under" | "Match";

export interface StockTakeBed {
  greenhouseBedId: string;
  greenhouseName: string;
  bayName: string;
  bedNumber: string;
  trayCount: number;
  pendingHandoverTrays: number;
}

export interface StockTakeRow {
  stockEntryId: string;
  instructionNumber?: string | null;
  cropType: string;
  variety?: string | null;
  trayType?: string | null;
  greenhouseId?: string | null;
  greenhouseName?: string | null;
  totalQuantity: number;
  fillingReserve: number;
  reservedQuantity: number;
  dispatchedQuantity: number;
  availableQuantity: number;
  systemTrays: number;
  bedTrays: number;
  difference: number;
  status: StockTakeStatus;
  isReadyForDispatch: boolean;
  entryDate: string;
  beds: StockTakeBed[];
}

export interface StockTakeSummary {
  batches: number;
  match: number;
  noBeds: number;
  over: number;
  under: number;
  systemTrays: number;
  bedTrays: number;
}

export interface StockTakePage {
  summary: StockTakeSummary;
  items: StockTakeRow[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface StockTakeParams {
  greenhouseId?: string;
  status?: StockTakeStatus;
  search?: string;
  pageNumber: number;
  pageSize: number;
}

export interface SaveStockTakeRequest {
  beds: Array<{ greenhouseBedId: string; trayCount: number }>;
  notes?: string;
}

export const greenhouseStockTakeApi = {
  get: async (params: StockTakeParams): Promise<StockTakePage> => {
    const { data } = await apiClient.get<ApiResponse<StockTakePage>>("/greenhouse-stock-take", { params });
    return data.data;
  },

  saveBeds: async (stockEntryId: string, payload: SaveStockTakeRequest): Promise<StockTakeRow> => {
    const { data } = await apiClient.put<ApiResponse<StockTakeRow>>(
      `/greenhouse-stock-take/${stockEntryId}/beds`,
      payload
    );
    return data.data;
  },
};
